import { Menu } from 'lucide-react';
import { useSetAtom } from 'jotai';
import { Breadcrumbs } from '@/components/breadcrumbs';
import { mobileNavOpenAtom } from '@/store/ui';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

export function Topbar() {
  const setMobileOpen = useSetAtom(mobileNavOpenAtom);

  return (
    <header className="bg-topbar-chrome sticky top-0 z-30 flex h-14 shrink-0 items-center gap-3 border-b px-4 md:px-6">
      <button
        type="button"
        onClick={() => setMobileOpen(true)}
        className="hover:bg-accent inline-flex size-9 shrink-0 items-center justify-center rounded-md transition-colors md:hidden"
        aria-label="Open navigation"
      >
        <Menu className="size-5" />
      </button>
      <Breadcrumbs />
      <div className="ml-auto flex items-center gap-1">
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  );
}
